// components/dialogs/OptionDialog.jsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Box,
  TextField,
} from "@mui/material";

import { Popover } from "@mui/material";

import { QueryBuilder } from "react-querybuilder";

import { QueryBuilderMaterial } from "@react-querybuilder/material";

import Api from "../../Api/Api";
import { toast } from "sonner";

export default function OptionDialog({
  filterOpen,
  anchorEl,
  closeFilter,
  fields,
  query,
  setQuery,
}) {
  return (
    <Popover
      open={filterOpen}
      anchorEl={anchorEl}
      onClose={closeFilter}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <Box
        sx={{
          p: 2,
          width: 700,
          maxHeight: 500,
          overflow: "auto",
          background: "#f5f7fa",
        }}
      >
        <QueryBuilderMaterial>
          <QueryBuilder
            fields={fields}
            query={query}
            onQueryChange={setQuery}
            controlClassnames={{
              queryBuilder: "queryBuilder-branches",
            }}
          />
        </QueryBuilderMaterial>

        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <Button
            size="small"
            onClick={() =>
              setQuery({
                combinator: "and",
                rules: [],
              })
            }
          >
            Clear
          </Button>

          <Button size="small" variant="contained" onClick={closeFilter}>
            Done
          </Button>
        </Box>
      </Box>
    </Popover>
  );
}
